

import { ControlProps, components, ValueContainerProps } from 'react-select';
import { SelectBoxControlWrapper, TagBoxControlWrapper, TagsBoxValueContainerWrapper } from '../styles';
import { FC } from 'react';

export const SelectBoxControl = (props: ControlProps<any, any>) => {
    return (
        <SelectBoxControlWrapper isFocused={props.isFocused} {...props.innerProps} {...props.innerRef}>
            {props.children}
        </SelectBoxControlWrapper>
    );
};
export const TagBoxControl = (props: ControlProps<any, any>) => {
    return (
        <TagBoxControlWrapper isFocused={props.isFocused} {...props.innerProps} {...props.innerRef}>
            {props.children}
        </TagBoxControlWrapper>
    );
};

export const SelectBoxValueContainer: FC<ValueContainerProps<any, any>> = (props) => {
    return <components.ValueContainer {...props} />;
};

export const TagsBoxValueContainer: FC<ValueContainerProps<any, any>> = (props) => {
    return <TagsBoxValueContainerWrapper>{props.children}</TagsBoxValueContainerWrapper>;
};


import { ControlProps, components, ValueContainerProps } from 'react-select';
import { SelectBoxControlWrapper, TagBoxControlWrapper, TagsBoxValueContainerWrapper } from '../styles';
import { FC } from 'react';

export const SelectBoxControl = (props: ControlProps<any, any>) => {
    return (
        <SelectBoxControlWrapper isFocused={props.isFocused} {...props.innerProps} {...props.innerRef}>
            {props.children}
        </SelectBoxControlWrapper>
    );
};
export const TagBoxControl = (props: ControlProps<any, any>) => {
    return (
        <TagBoxControlWrapper isFocused={props.isFocused} {...props.innerProps} {...props.innerRef}>
            {props.children}
        </TagBoxControlWrapper>
    );
};

export const SelectBoxValueContainer: FC<ValueContainerProps<any, any>> = (props) => {
    return <components.ValueContainer {...props} />;
};

export const TagsBoxValueContainer: FC<ValueContainerProps<any, any>> = (props) => {
    return <TagsBoxValueContainerWrapper>{props.children}</TagsBoxValueContainerWrapper>;
};
